import React from 'react'
import NextImage from 'next/image'
import { Text, TextBlock } from '@/components/common'
import { Image, ContentBlock } from '../types'

export interface Props {
  image?: Image
  items: ContentBlock[]
  className?: string
}

const Community: React.FC<Props> = ({ image, items, className }) => {
  return (
    <div className={className}>
      {image && (
        <div className="mx-auto mb-8 max-w-[680px] md:mb-12">
          <NextImage
            alt={image.description}
            src={`https:${image.file.url}?w=680`}
            width={image.file.details.image.width}
            height={image.file.details.image.height}
            loading="lazy"
          />
        </div>
      )}

      <div className="mx-auto max-w-[1360px] px-6 md:flex md:justify-around lg:px-8">
        {items.map(({ id, title, text }) => (
          <div
            key={id}
            className="mb-8 w-full last:mb-0 md:mb-0 md:w-1/2 md:pr-12 last:md:pl-12 last:md:pr-0"
          >
            <Text as="h3" preset="heading.lg" className="mb-4">
              {title}
            </Text>

            <TextBlock document={text} />
          </div>
        ))}
      </div>
    </div>
  )
}

export default Community
